import { useEffect, useState } from "react";
import {
  collection,
  query,
  orderBy,
  onSnapshot,
  deleteDoc,
  doc,
} from "firebase/firestore";
import { db } from "../firebase";
import "../styles/AdminDashboard.css";

export default function AdminDashboard() {
  const [demoBookings, setDemoBookings] = useState([]);
  const [contactMessages, setContactMessages] = useState([]);

  useEffect(() => {
    const demoQuery = query(
      collection(db, "demoBookings"),
      orderBy("createdAt", "desc")
    );

    const unsubDemo = onSnapshot(demoQuery, (snapshot) => {
      const list = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setDemoBookings(list);
    });

    const contactQuery = query(
      collection(db, "contactMessages"),
      orderBy("createdAt", "desc")
    );

    const unsubContact = onSnapshot(contactQuery, (snapshot) => {
      const list = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setContactMessages(list);
    });

    return () => {
      unsubDemo();
      unsubContact();
    };
  }, []);

  /* 🔥 DELETE FUNCTION */
  const handleDelete = async (collectionName, id) => {
    const confirmDelete = window.confirm("Are you sure you want to delete?");
    if (!confirmDelete) return;

    try {
      await deleteDoc(doc(db, collectionName, id));
    } catch (error) {
      console.error("Delete error:", error);
    }
  };

  return (
    <div className="admin-dashboard">
      <h1 className="admin-title">Admin Dashboard</h1>

      {/* SUMMARY */}
      <div className="admin-summary">
        <div className="summary-card">
          <h3>Total Demo Bookings</h3>
          <p>{demoBookings.length}</p>
        </div>

        <div className="summary-card">
          <h3>Total Contact Messages</h3>
          <p>{contactMessages.length}</p>
        </div>
      </div>

      {/* DEMO BOOKINGS */}
      <h2 className="admin-section-title">Demo Bookings</h2>
      <div className="admin-table-wrapper">
        <table className="admin-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Phone</th>
              <th>Course</th>
              <th>Category</th>
              <th>Institution</th>
              <th>Message</th>
              <th>Date</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {demoBookings.map((item) => (
              <tr key={item.id}>
                <td>{item.name}</td>
                <td>{item.email}</td>
                <td>{item.phone}</td>
                <td>{item.course}</td>
                <td>{item.category}</td>
                <td>{item.institutionOrOrganization || "—"}</td>
                <td>{item.message || "—"}</td>
                <td>
                  {item.createdAt?.toDate
                    ? item.createdAt.toDate().toLocaleString()
                    : "—"}
                </td>
                <td>
                  <button
                    className="delete-btn"
                    onClick={() =>
                      handleDelete("demoBookings", item.id)
                    }
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* CONTACT MESSAGES */}
      <h2 className="admin-section-title">Contact Messages</h2>
      <div className="admin-table-wrapper">
        <table className="admin-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Contact</th>
              <th>Email</th>
              <th>Message</th>
              <th>Date</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {contactMessages.map((item) => (
              <tr key={item.id}>
                <td>{item.name}</td>
                <td>{item.contact}</td>
                <td>{item.email}</td>
                <td>{item.message}</td>
                <td>
                  {item.createdAt?.toDate
                    ? item.createdAt.toDate().toLocaleString()
                    : "—"}
                </td>
                <td>
                  <button
                    className="delete-btn"
                    onClick={() =>
                      handleDelete("contactMessages", item.id)
                    }
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
